import { useMemo } from "react";

const useSAPMode = (showAssetReferences, customCaptions) => {
	const isSAPMode = Boolean(showAssetReferences);

	const tableConfig = useMemo(() => {
		if (isSAPMode) {
			return {
				headers: [
					customCaptions?.asset || "Asset",
					customCaptions?.assetReference || "FLOC",
					"Description",
					customCaptions?.assetPlannerGroup || "Planner Group",
					customCaptions?.assetMainWorkCenter || "Work Center"
				],
				columns: [
					"assetNo",
					"referenceName", 
					"description",
					"plannerGroup",
					"workCenter"
				]
			};
		} else {
			return {
				headers: [
					customCaptions?.asset || "Asset",
					"Description"
				],
				columns: [
					"assetNo",
					"description"
				]
			};
		}
	}, [isSAPMode, customCaptions]);

	const dialogConfig = useMemo(() => {
		return {
			showAddButton: !isSAPMode,
			showImportButton: true,
			editFields: isSAPMode 
				? [
					{ name: "assetNo", label: customCaptions?.asset || "Asset", required: true, readOnly: true },
					{ name: "referenceName", label: customCaptions?.assetReference || "FLOC", required: true },
					{ name: "description", label: "Description", required: true },
					{ name: "plannerGroup", label: customCaptions?.assetPlannerGroup || "Planner Group", required: false },
					{ name: "workCenter", label: customCaptions?.assetMainWorkCenter || "Work Center", required: false }
				]
				: [
					{ name: "assetNo", label: customCaptions?.asset || "Asset", required: true },
					{ name: "description", label: "Description", required: true }
				]
		};
	}, [isSAPMode, customCaptions]);

	const getRowDisplayData = (row) => {
		if (isSAPMode) {
			return {
				assetNo: row.assetNo,
				referenceName: row.referenceName,
				description: row.description,
				plannerGroup: row.plannerGroup,
				workCenter: row.workCenter
			};
		} else {
			return {
				assetNo: row.assetNo,
				description: row.description
			};
		}
	};

	const getEditableData = (row) => {
		if (isSAPMode) {
			return {
				assetId: row.assetId,
				referenceId: row.referenceId,
				assetNo: row.assetNo,
				referenceName: row.referenceName || "",
				description: row.description || "",
				plannerGroup: row.plannerGroup || "",
				workCenter: row.workCenter || ""
			};
		} else {
			return {
				assetId: row.assetId,
				assetNo: row.assetNo,
				description: row.description
			};
		}
	};

	const validateRowData = (data) => {
		const errors = {};
		
		if (!data.assetNo?.trim()) {
			errors.assetNo = "Asset number is required";
		}

		if (isSAPMode) {
			if (!data.referenceName?.trim()) {
				errors.referenceName = "FLOC is required";
			}
			if (!data.description?.trim()) {
				errors.description = "Description is required";
			}
		} else {
			if (!data.description?.trim()) {
				errors.description = "Description is required";
			}
		}

		return {
			isValid: Object.keys(errors).length === 0,
			errors
		};
	};

	return {
		isSAPMode,
		tableConfig,
		dialogConfig,
		getRowDisplayData,
		getEditableData,
		validateRowData
	};
};

export default useSAPMode;
